import { appstr } from "../utils/appstr";
import { enumFormulaScope, enumMatchSubs, kBlockedFieldTag, kFormulaOptions } from "../constants";
import { GetFieldDefBy } from "../utils/GetFieldDefBy";
import { isBlockedField } from "../utils/FormatFieldValue";
import { QRule } from "./QRule";

export class QFormulaRule extends QRule {
  constructor() {
    super();
    this.fScope = null;
    this.fFormulaType = null;
    this.fFormulaStr = null;
    //    this.fConcatCache = null;

    this.fFieldID1 = null;
    this.fFieldID2 = null;

    this.fMapCache = null;
    this.fMapDefault = null;
    this.fRuleCache = null;
  }

  InitFormulaRule(formulaType) {
    this.ResetCache();
    this.fFormulaType = formulaType;
    this.InitRule(enumMatchSubs.matchonly, 0, false);
  }

  InitFormulaRuleFromDB(thisFormula) {
    if (!thisFormula["formulaType"] || kFormulaOptions.indexOf(thisFormula["formulaType"]) == -1)
      this.InitFormulaRule("math");
    else this.InitFormulaRule(thisFormula["formulaType"]);

    var formulaType = thisFormula["formulaType"];

    if (thisFormula["formulaScope"] && enumFormulaScope[thisFormula["formulaScope"]] != null)
      this.SetScope(enumFormulaScope[thisFormula["formulaScope"]]);
    else this.SetScope(enumFormulaScope.directreports);

    if (
      ["sumif", "averageif", "countif", "sum", "average", "map", "max", "min"].indexOf(
        formulaType
      ) > -1 &&
      thisFormula["formulaField"]
    )
      this.SetFieldID1(thisFormula["formulaField"]);

    if (
      ["sumif", "averageif", "countif", "math", "concatenate", "map"].indexOf(formulaType) > -1 &&
      thisFormula["formulaDef"]
    ) {
      this.SetFormulaStr(thisFormula["formulaDef"]);
      this.SetComplexDef(thisFormula["formulaDef"]);
    }
    /*
	if (thisFormula['formulaDef'])
	{
        this.SetFormulaStr(thisFormula['formulaDef']);
        this.SetComplexDef(thisFormula['formulaDef']);
    }
    */
    this.SetIsComplex(!thisFormula["formulaPairs"] || thisFormula["formulaPairs"].length == 0);
    if (!thisFormula["formulaDef"] && this.GetIsComplex() == false) {
      //no rule information provided
      this.SetNoRule(true);
    }
  }

  ResetCache() {
    this.fRuleCache = {};
  }

  CheckCache(objID) {
    if (this.fRuleCache == null) this.ResetCache();
    return this.fRuleCache[objID];
  }

  AddToCache(objID, value) {
    if (this.fRuleCache == null) this.ResetCache();
    this.fRuleCache[objID] = value;
  }

  GetFormulaType() {
    return this.fFormulaType;
  }

  GetFormulaStr() {
    return this.fFormulaStr;
  }

  GetFieldID1() {
    return this.fFieldID1;
  }

  GetFieldID2() {
    return this.fFieldID2;
  }

  SetFieldID1(fieldID) {
    this.fFieldID1 = fieldID;
  }

  SetFieldID2(fieldID) {
    this.fFieldID2 = fieldID;
  }

  SetFormulaStr(formulaStr) {
    this.fFormulaStr = formulaStr;
    this.fConcatCache = null;
    this.fMapCache = null;
    this.fMapDefault = null;
  }

  NewObject() {
    return new QFormulaRule();
  }

  // xml output
  DoOutputSubElements(stream) {
    this.OutputSimpleElement("scope", this.fScope, stream);
    this.OutputSimpleElement("type", this.fFormulaType, stream);

    if (this.fFormulaStr) this.OutputSimpleElement("str", this.fFormulaStr, stream);

    if (this.fFieldID1) {
      if (this.fFieldID2 == null) this.fFieldID2 = "";
      this.OutputElementPair("fields", this.fFieldID1, this.fFieldID2, stream);
    }
  }

  // xml load
  DoLoadSubElements(objTree) {
    this.fScope = objTree.GetValueForChild("scope", true);
    this.fFormulaType = objTree.GetValueForChild("type", false);
    if (this.fFormulaType == null) this.fFormulaType = "countif";

    this.fFormulaStr = objTree.GetValueForChild("str", false);

    var values = objTree.GetValueListForChild("fields", false);
    if (values) {
      this.fFieldID1 = values[0];
      this.fFieldID2 = values[1];
    }
  }

  // new json output
  OutputToJSON() {
    var ruleJSON = {};
    ruleJSON["scope"] = this.fScope;
    ruleJSON["formulaType"] = this.fFormulaType;
    if (this.fFormulaStr) {
      ruleJSON["formulaDef"] = this.fFormulaStr;
      //ruleJSON['complexDef'] = this.fComplexDef;
    }
    if (this.fFieldID1) {
      if (this.fFieldID2 == null) this.fFieldID2 = "";
      ruleJSON["fields"] = [this.fFieldID1, this.fFieldID2];
    }
    //ruleJSON['logicalop'] = this.fLogicalOperator;
    //ruleJSON['isComplex'] = this.fComplexRule;
    return ruleJSON;
  }

  // new json load
  LoadFromJSON(json) {
    this.fScope = json["scope"];
    this.fFormulaType = json["formulaType"] ? json["formulaType"] : "countif";
    this.fFormulaStr = json["formulaDef"];
    //if (this.fComplexRule)
    //	this.fFormulaStr = json['complexDef'];
    if (json["formulaDef"]) {
      this.SetIsComplex(true);
      this.SetComplexDef(json["formulaDef"]);
    }

    var fields = json["fields"];
    if (fields) {
      this.fFieldID1 = fields[0];
      this.fFieldID2 = fields[1];
    }
    //this.fComplexRule = json['isComplex'];
    //this.fLogicalOperator  = json['logicalop'];
  }

  DoClone(cloneFrom) {
    this.fScope = cloneFrom.fScope;

    this.fFormulaType = cloneFrom.fFormulaType;
    this.fFormulaStr = cloneFrom.fFormulaStr;

    if (this.fComplexRule) {
      this.fFormulaStr = this.fComplexDef;
    }

    this.fFieldID1 = cloneFrom.fFieldID1;
    this.fFieldID2 = cloneFrom.fFieldID2;
  }

  DoUpdateFrom(updateFrom) {
    this.DoClone(updateFrom);
  }

  GetScope() {
    return this.fScope;
  }

  SetScope(scope) {
    this.fScope = scope;
  }

  DoRulesMatch(compareTo) {
    if (this.fScope !== compareTo.fScope) return false;

    if (this.fFormulaType !== compareTo.fFormulaType) return false;

    if (this.fFormulaStr !== compareTo.fFormulaStr) return false;

    if (this.fFieldID1 !== compareTo.fFieldID1) return false;

    if (this.fFieldID2 !== compareTo.fFieldID2) return false;

    return true;
  }

  GetSumVal(dbObj) {
    var f1 = this.GetFieldID1();

    if (f1 == null || dbObj.IsAux()) return 0.0;
    var lookupDef = dbObj.GetFieldDefByID(f1);
    if (!lookupDef) lookupDef = dbObj.GetFieldDefByName(f1);
    if (!lookupDef) lookupDef = dbObj.GetFieldDefByName(f1.replaceAll("^", ""));
    if (!lookupDef) return 0.0;

    var v = dbObj.GetFieldValue(lookupDef);
    if (v == null || v == "") return 0.0;
    if (isBlockedField(v)) return kBlockedFieldTag;

    v = parseFloat(v);
    if (isNaN(v)) v = 0.0;

    return v;
  }

  ProcessSlice(dbObj, curDef, sliceLeft) {
    var f1 = this.GetFieldID1();
    var lookupDef = dbObj.GetFieldDefByID(f1);
    if (lookupDef == null) return "";

    var v = dbObj.GetFieldValue(lookupDef);
    if (v == null || v == "") return "";

    var s = this.GetFormulaStr();
    var sliceVal = parseInt(s);
    if (isNaN(sliceVal)) {
      var p = v.split(s);
      var l = p.length;
      if (l == 1) return v;

      if (sliceLeft) return p[0];
      else return p[l - 1];
    } else {
      var l1 = 0;
      var l2;
      if (sliceLeft) l2 = sliceVal;
      else {
        l2 = v.length;
        l1 = l2 - sliceVal;
      }

      return v.toString().substring(l1, l2);
    }
  }

  CheckMapCache(jObj, value) {
    var result = null;
    if (this.fMapCache == null) {
      this.fMapCache = [];
      for (var key in jObj) {
        var kLen = key.length;
        if (kLen > 0 && key[0] == "$") {
          if (kLen == 1) {
            var v = jObj[key];
            v = v.toString();
            this.fMapDefault = v;
          } else {
            var k = key.substring(1).toLowerCase();
            this.fMapCache.push(k);
          }
        }
      }
    }

    var n2 = this.fMapCache.length;
    for (var i = 0; i < n2; i++) {
      var m = this.fMapCache[i];
      if (value.indexOf(m) != -1) {
        var mappedVal = jObj["$" + m];
        return mappedVal;
      }
    }

    return result;
  }

  ProcessMap(dbObj) {
    //TODO: working with maps sucks.
    var f1 = this.GetFieldID1();
    var mapDef = dbObj.GetFieldDefByID(f1);
    if (!mapDef) mapDef = dbObj.GetFieldDefByName(f1);
    if (mapDef == null) return "";

    var v = dbObj.GetFieldValue(mapDef);
    if (v == null) v = "";
    var vl = v.toString().toLowerCase();
    var s = this.GetFormulaStr();
    try {
      //TODO: Now people can't use apostrophes. Make sure you verify that there are no double quotes first!
      s = s.toString();
      var doReplace = s.split('"').length == 1;
      if (doReplace) s = s.replaceAll("'", '"');
      s = "{" + s + "}";
      var obj = JSON.parse(s);
      //var keys = Object.keys(obj);
      //keys.every(function(a){return a.toLowerCase()});
      var value = this.CheckMapCache(obj, vl);
      if (value == null) {
        value = obj[v] || obj[vl];
        if (value == null && this.fMapDefault != null) return this.fMapDefault;
      }

      return value;
    } catch (err) {
      return appstr("refinvalid");
    }
  }

  ProcessMath(dbObj, curDef, docRef) {
    var c = this.ProcessConcat(dbObj, curDef, docRef, true, true);
    if (isBlockedField(c)) return kBlockedFieldTag;
    var v = c.indexOf("{");
    if (v != -1 || c == "") return appstr("refinvalid");

    var e = "";
    try {
      e = eval(c);
    } catch (err) {
      e = appstr("refinvalid");
    }
    return e;
  }

  GetConcatFormula() {
    return this.GetFormulaStr();
  }
}
